export const CONFERENCE = '/conference'
export const CONFERENCE_SITE_CONTENT = `${CONFERENCE}/site-content`
export const CONFERENCE_CREATE_PAGE = `${CONFERENCE_SITE_CONTENT}/new`
export const CONFERENCE_VIEW_PAGE = `${CONFERENCE_SITE_CONTENT}/:id`
export const CONFERENCE_ARTICLE_SUBMISSION_MANAGEMENT = `${CONFERENCE}/submission-management`
export const CONFERENCE_ARTICLE_SUBMISSION_MANAGEMENT_BY_ID = `${CONFERENCE}/submission-management/:id`
export const CONFERENCE_MAGAZINE_DESIGNER = `${CONFERENCE}/for-designers`
